const WORKING = {
    DURATION: 250,
    SCALE: 1.2,
    EASE: Phaser.Math.Easing.Linear,
};

export default class Icon extends Phaser.GameObjects.Sprite {
    private tweenWorking: Phaser.Tweens.Tween | null;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'gui/enrage/enrage_off');

        this.tweenWorking = null;

        this.setInteractive({ useHandCursor: true });
        this.on('pointerdown', () => this.emit('click'));
    }

    setReady() {
        let frame = 'gui/enrage/enrage_on';
        this.setFrame(frame);
    }

    setCharging() {
        let frame = 'gui/enrage/enrage_off';
        this.setFrame(frame);

        this.tweenWorking?.stop();
        this.setScale(1);
    }

    startWorking() {
        this.tweenWorking = this.scene.tweens.add({
            targets: this,
            duration: WORKING.DURATION,
            ease: WORKING.EASE,
            scaleX: WORKING.SCALE,
            scaleY: WORKING.SCALE,
            yoyo: true,
            repeat: -1,
        });
    }
}
